/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { Options, Unwrappable, RequestResult } from '../.kubb/client'
import type {
  CloseAllIsolatedPositionsOptions,
  CloseAllIsolatedPositionsResponses,
} from '../types/CloseAllIsolatedPositions'
import { client, withUnwrap } from '../.kubb/client'

/**
 * @summary Close all open isolated positions in one request
 * {@link /v1/positions/close/all}
 */
export function closeAllIsolatedPositions<ThrowOnError extends boolean = true>(
  options: Options<CloseAllIsolatedPositionsOptions, ThrowOnError> = {},
): Unwrappable<RequestResult<CloseAllIsolatedPositionsResponses, ThrowOnError>> {
  const { client: request = client, ...config } = options

  return withUnwrap(
    request({
      method: 'POST',
      url: '/v1/positions/close/all',
      security: [
        { type: 'http', scheme: 'bearer' },
        { type: 'apiKey', name: 'Authorization', in: 'header' },
      ],
      ...config,
      throwOnError: config.throwOnError ?? true,
    }) as Promise<RequestResult<CloseAllIsolatedPositionsResponses, ThrowOnError>>,
  )
}
